import { Grid, Typography } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";
import { COLORS } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const Container = styled(Grid)(({ theme }) => ({
  "& .highlighted": {
    // border: `2px solid ${theme.palette.error.light} !important`,
    borderRadius: "3px",
    maxWidth: "calc(100% - 4px)",
    backgroundColor: lighten(COLORS.yellow_gradients.yellow, 0.2),
  },
}));

export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
});

export const PendingApprovalsContainer = styled(Grid)({
  "&:hover, &:hover .MuiTypography-root": {
    cursor: "pointer",
  },
});

export const LastTimesheetUsageInfoContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  "& .MuiIconButton-root": {
    height: "30px",
  },
});
export const LastUsageAndConfirmation = styled(Typography)({
  width: "100%",
  textOverflow: "ellipsis",
  overflow: "hidden",
  margin: 0,
  whiteSpace: "break-spaces",
  lineHeight: "1.1rem",
  // display: "flex",
});
